import React , { Component } from 'react';
import { Route,Switch } from 'react-router-dom';
import HomeOne from '../MainContent/Pages/HomeOne';
import Login from '../MainContent/Pages/Login';
import PasswordForget from '../MainContent/Pages/PasswordForget';
import SignUp from '../MainContent/Pages/SignUp';
import Kugi from '../Kugi/Kugi';
import UnduhBukuKugi from '../UnduhBukuKugi/UnduhBukuKugi';
import UnduhTemplateKugi from '../UnduhBukuKugi/UnduhTemplateKugi';
import UnduhSkemaRDF from '../UnduhBukuKugi/UnduhSkemaRDF';
import Crud from '../Crud/Crud';
import FeatureCatalog from '../Crud/FeatureCatalog';
import FeatureType from '../Crud/FeatureType';
import PencarianKugi from '../PencarianKugi/PencarianKugi';
import Dictionary from '../Crud/Dictionary';
import PencarianDetail from '../PencarianKugi/PencarianDetail';
import Map from '../Map/Map';
import Data3d from '../Data3d/Data3d';
import Cms from '../Cms/Cms';
import Generaterdf from '../Crud/Generaterdf';
import Tentang from '../Tentang/Tentang';
import Kugicatdetail from '../Kugi/Kugicatdetail';

class mainbuilder extends Component{
    render(){
        return(
          <Switch>
              <Route exact path="/" component={HomeOne} />
              <Route exact path="/index_1" component={HomeOne} />
              <Route exact path="/unduhbukukugi" component={UnduhBukuKugi} />
              <Route exact path="/unduhtemplatekugi" component={UnduhTemplateKugi} />
              <Route exact path="/unduhskemardf" component={UnduhSkemaRDF} />
              <Route exact path="/pencarianbig" component={PencarianKugi} />
              <Route exact path="/kugi" component={Kugi} />
              <Route exact path="/crud" component={Crud} />
              <Route exact path="/featurecatalog" component={FeatureCatalog} />
              <Route exact path="/featuretype" component={FeatureType} />
              <Route exact path="/dictionary" component={Dictionary} />
              <Route exact path="/searchresult" component={PencarianDetail} />
              <Route exact path="/map" component={Map} />
              <Route exact path="/data3d" component={Data3d} />
              <Route exact path="/cms" component={Cms} />
              <Route exact path="/generaterdf" component={Generaterdf} />
              <Route exact path="/tentang" component={Tentang} />
              <Route exact path="/kugicatdetail" component={Kugicatdetail} />
              <Route path={`${process.env.PUBLIC_URL}/login`} component={Login} />
              <Route path={`${process.env.PUBLIC_URL}/password_forget`} component={PasswordForget} />
              <Route path={`${process.env.PUBLIC_URL}/signup`} component={SignUp} />
          </Switch>
        );
    }
}

export default mainbuilder;
